<div fxLayout="row" class="footer">
  <div fxFlex="100%">
    <div class="footer__link-legal">
      <a [routerLink]="'/privacy'" class="header__nav-link"> Privacy Policy </a>
      <a [routerLink]="'/terms'" class="header__nav-link"> Terms of Service</a>
      <a [routerLink]="'/cookies'" class="header__nav-link"> Cookies Policy</a>
    </div>
    <div class="footer__link">
      <a href="https://www.linkedin.com/in/anastasia-paukste-7a15958/">(c) thewebbird</a>
    </div>
  </div>
</div>
